let convertRecurring = function(id) {
	this.$router.push({
		name: "InvoiceRecConvert",
		params: { idinv: id, convert: "convert" },
	});
};
export default convertRecurring;
